import { Directive, ElementRef, Input, AfterViewInit, NgZone } from '@angular/core';

@Directive({
  selector: '[truncateLines]',
})
export class TruncateLinesDirective implements AfterViewInit {
  @Input('truncateLines') lines: number = 2;
  @Input() truncateText: string = '';

  constructor(
    private el: ElementRef,
    private zone: NgZone
  ) {}

  ngAfterViewInit() {
    // Defer until DOM layout is ready
    this.zone.runOutsideAngular(() => setTimeout(() => this.truncate(), 0));
  }

  private truncate() {
    const element = this.el.nativeElement as HTMLElement;
    const lineHeight = 14;
    const maxHeight = lineHeight * this.lines;

    // Reset to full text first
    element.textContent = this.truncateText;

    // If it already fits, do nothing
    if (element.scrollHeight <= maxHeight) return;

    const words = this.truncateText.split(' ');
    let truncated = '';

    // Add words one by one until it exceeds the height limit
    for (let i = 0; i < words.length; i++) {
      const testText = truncated ? truncated + ' ' + words[i] : words[i];
      element.textContent = testText;

      if (element.scrollHeight > maxHeight) {
        element.textContent = truncated.trim();
        return;
      }

      truncated = testText;
    }

    // Fallback: show full if somehow still fits
    element.textContent = truncated.trim();
  }
}
